/**
 * ArrayUtils are used for easier work with parsing arrays.
 * @class ArrayUtils
 */
export class ArrayUtils {

    /**
     * Returns array of numbers from string.
     * @method numberArray
     * @param s string to parse to array.
     * @param delimiter string to split s parameter to array. Default: ;
     * @return Array<number>
     */
    static numberArray(s: string, delimiter: string = ';'): Array<number> {
        var arr: Array<number> = s.split(delimiter).map(Number);
        return arr;
    }

    /**
     * Returns array of strings from string.
     * @method stringArray
     * @param s string to parse to array.
     * @param delimiter string to split s parameter to array. Default: ;
     * @return Array<string>
     */
    static stringArray(s: string, delimiter: string = ';'): Array<string> {
        var arr: Array<string> = s.split(delimiter);
        return arr;
    }

    /**
     * Returns array of arrays of numbers from string.
     * @method arraysNumbers
     * @param s string to parse to array.
     * @param delimiter string to split s parameter to array. Default: ;
     * @param numbersDelimiter string to split arrays of numbers to array. Default: ;
     * @return Array<Array<number>>
     */
    static arraysNumbers(s: string, delimiter: string = ';', numbersDelimiter: string = ';'): Array<Array<number>> {
        var helpArray: Array<string> = s.split(delimiter);
        var arr: Array<Array<number>> = [];
        if (helpArray != null) {
            for (var i: number = 0; i < helpArray.length; i++) {
                arr.push(this.numberArray(helpArray[i], numbersDelimiter));
            }
        }
        return arr;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/ArrayUtils.ts
 **/